import { Application, Text } from "pixi.js"
import SimpleEntity, { SimpleEntityOptions } from "../SimpleEntity"

export type MagicParticleOptions = {
	amp?: number
	lifespan?: number
} & SimpleEntityOptions

export default class MagicParticle extends SimpleEntity {

	amp
	lifespan
	currentLifespan

	constructor({ amp = 1, lifespan = 5, ...rest }: MagicParticleOptions) {
		super({
			...rest,

			color: 'transparent',
		})

		this.amp = amp
		this.lifespan = lifespan
		this.currentLifespan = lifespan
	}

	tick(delta: number) {
		super.tick(delta)

		this.currentLifespan -= delta

		if (this.currentLifespan <= 0) {
			this.kill()
		}
	}

	createGraphics() {
		const text = new Text(this.symbol, { fontFamily: 'Segoe UI Emoji', fontSize: this.size, align: 'center' })
		text.anchor.set(0.5)
		return text

	}

	addGraphics(pixi: Application) {
		super.addGraphics(pixi)

		if (this.graphics) {
			this.graphics.zIndex = -1
		}
	}

	getLifespanRatio() {
		return this.currentLifespan / this.lifespan
	}
}